import { Get, Post, Delete } from '../requestBuilder/buildFetchRequest';
import GridSettings from './GridSettings';

export const getGridSettings = (gridName: string): Promise<GridSettings> => (
  Get(`/api/gridSettings/${gridName}`)
    .Execute()
);

export const updateGridSettings = (gridName: string, content: string | object): Promise<void> => (
  Post(`/api/gridSettings/${gridName}`)
    .AddBody({
      gridContent: typeof content === 'string' ? content : JSON.stringify(content),
    })
    .Execute()
);

export const deleteGridSettings = (gridName: string): Promise<void> => (
  Delete(`/api/gridSettings/${gridName}`)
    .Execute()
);
